import React, { useMemo, useRef } from "react";
import { MapContainer, GeoJSON } from "react-leaflet";
import L from "leaflet";
import "./IndiaMap124.css";

const centerIndia = [22.5, 82];

function valueToColor(p) {
  const clamp = Math.max(0, Math.min(1, Number.isFinite(p) ? p : 0));
  const r = Math.round(243 + (107 - 243) * clamp);
  const g = Math.round(232 + (33 - 232) * clamp);
  const b = Math.round(255 + (168 - 255) * clamp);
  return `rgb(${r},${g},${b})`;
}

export default function IndiaMap({ geo, metrics, metric }) {
  const geoRef = useRef(null);

  const styleFn = (feature) => {
    const name = feature.properties?.st_nm;
    const val = metrics?.[name]?.[metric] ?? 0;
    return {
      fillColor: valueToColor(val),
      color: "#4c1d95",
      weight: 1,
      fillOpacity: 0.85,
    };
  };

  const highlightStyle = {
    weight: 3,
    color: "#9333ea",
    dashArray: "3",
    fillOpacity: 0.85,
  };

  const onEachFeature = (feature, layer) => {
    const name = feature.properties?.st_nm;
    const data = metrics?.[name] || {};
    const pct = (v) =>
      v === null || v === undefined ? "—" : `${(v * 100).toFixed(1)}%`;

    const html = `
      <div>
        <div><b>${name}</b></div>
        <div>Heard: <b>${pct(data.heard)}</b></div>
        <div>Availing: <b>${pct(data.availing)}</b></div>
        <div>Not aware: <b>${pct(data.not_aware)}</b></div>
      </div>
    `;

    layer.bindTooltip(html, { sticky: true, direction: "top", opacity: 0.95 });

    layer.on({
        mouseover: (e) => {
          e.target.openTooltip();
        },
        mouseout: (e) => {
          e.target.closeTooltip();
        },
      });
      
  };

  const bounds = useMemo(() => {
    try {
      const gj = L.geoJSON(geo);
      return gj.getBounds();
    } catch {
      return null;
    }
  }, [geo]);

  return (
    <MapContainer
      className="map-container"
      center={centerIndia}
      zoom={5}
      scrollWheelZoom={false}
      bounds={bounds || undefined}
      attributionControl={false}
    >
      <GeoJSON
        ref={geoRef}
        data={geo}
        style={styleFn}
        onEachFeature={onEachFeature}
      />
      <div className="legend">
        <div>Awareness ({metric})</div>
        <div className="legend-bar"></div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>0%</span><span>100%</span>
        </div>
      </div>
    </MapContainer>
  );
}
